/**
 * Adapter AUCR-799 — converte o ProjectLandingPageConfig (resposta de
 * Project/BuildProjectLandingPage, campos em inglês) para o objeto `projeto`
 * esperado pelo componente PaginaProjeto.vue (contrato-de-dados.md).
 *
 * extras:
 *   - fileProjectList: lista de fotos da galeria (fileProjectService.listByProjectIdAndType)
 *   - captacaoAberta:  boolean (reusar o computed showDonationButton do container)
 *   - targetAudienceName: nome do público-alvo resolvido pelo container
 */

// Lei de incentivo (AUC só tem 4): id -> chave do mapa LEIS do componente.
const INCENTIVE_LAW_KEY = {
  1: 'ECA',      // Estatuto da Criança e do Adolescente
  2: 'IDOSO',    // Estatuto do Idoso
  3: 'ESPORTE',  // Lei Federal do Esporte
  4: 'CULTURA',  // Lei de Incentivo à Cultura (Rouanet)
};

// Extrai o número oficial do ODS (1..17) de um item da odsList (best-effort).
function odsCode(item) {
  if (item == null) return null;
  if (typeof item === 'number') return item >= 1 && item <= 17 ? 'ODS' + item : null;
  const src = String(item.title || item.name || item.code || item.ods || item.id || '');
  const m = src.match(/\b(1[0-7]|[1-9])\b/);
  return m ? 'ODS' + m[1] : null;
}

function urlOf(file) {
  return file && file.path ? file.path : null;
}

export function mapToProjetoContrato(projectLP, extras) {
  extras = extras || {};
  const lp = projectLP || {};
  const p = lp.project || {};
  const inst = p.institution || {};
  const entity = inst.entity || {};

  const galeria = (extras.fileProjectList || [])
    .map((x) => ({ url: urlOf(x.file), legenda: (x.file && x.file.name) || null }))
    .filter((g) => g.url);

  // coverage.name é texto livre ("São Paulo, SP, Brasil"); pega só a cidade
  // (antes da 1ª vírgula), igual ao formatCoverageName da página antiga. Dedup.
  const cidades = (p.coverageList || [])
    .map((c) => (c && c.name ? String(c.name).split(',')[0].trim() : null))
    .filter(Boolean)
    .filter((nome, i, arr) => arr.indexOf(nome) === i);

  const tagsODS = (p.odsList || []).map(odsCode).filter(Boolean);

  return {
    nome: p.fullName || p.shortName || '',
    descricao: lp.minibio || p.objective || '',
    leiIncentivo: INCENTIVE_LAW_KEY[p.incentiveLawId] || 'FIA',
    urlDoacao: extras.urlDoacao || '#doar',
    urlSimulador: null, // slot #simulador é usado
    captacaoAberta: !!extras.captacaoAberta,

    tagsCausa: p.cause && p.cause.name ? [p.cause.name] : [],
    tagsPublico: extras.targetAudienceName ? [extras.targetAudienceName]
      : (p.targetAudience && p.targetAudience.name ? [p.targetAudience.name] : []),
    tagsODS: tagsODS,

    cidades: cidades,
    ufs: [], // coverage do AUC não separa UF (só `name`)

    valorAprovado: Number(p.totalValue) || 0,
    // A barra de captação real usa totalDonatedValueWithCapturedValue (mesmo campo do DonationsBar antigo).
    valorCaptado:
      Number(p.totalDonatedValueWithCapturedValue != null
        ? p.totalDonatedValueWithCapturedValue
        : p.capturedValue) || 0,

    qtdBeneficiarios: Number(p.directBeneficiaries) || 0,
    qtdBeneficiariosIndiretos: Number(p.indirectBeneficiaries) || 0,

    objetivo: p.objective || '',
    justificativa: p.socialProblem || null,

    fotoCapaUrl: urlOf(lp.heroFile) || (galeria[0] && galeria[0].url) || null,
    galeria: galeria,
    videoUrl: lp.videoUrl || null,

    instituicao: {
      razaoSocial: entity.name || entity.socialReason || '',
      cnpj: entity.cnpj || null,
      naturezaJuridica: null,
      descricao: inst.mission || null,
      logoUrl: urlOf(inst.file),
      instagramUrl: inst.instagram || null,
    },
  };
}

export default mapToProjetoContrato;
